import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08813e73"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "image-container",
  style: {"min-width":"160px","min-height":"160px"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "marker-container",
  style: {"position":"absolute","left":"15px","top":"15px"}
}
const _hoisted_5 = { class: "media-body" }
const _hoisted_6 = { class: "message-detail-position" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Ort:", -1))
const _hoisted_8 = { class: "media-heading" }
const _hoisted_9 = { class: "wdw-details" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Meldung Nr.", -1))
const _hoisted_11 = { class: "wdw-details" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Gemeldet am", -1))
const _hoisted_13 = { class: "wdw-details" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Kategorie:", -1))
const _hoisted_15 = { class: "wdw-details" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Status:", -1))

import useConverter from '@/composables/general/useConverter';
import { Message } from '@/models/message.model';
import { messageStateTypeMappedToGermanText } from '@/types/message/state.type';
import { PropType } from 'vue';
import useStringManip from '@/composables/general/useStringManip';

export default /*#__PURE__*/_defineComponent({
  props: { message: { type: Object as PropType<Message>, required: true } },
  emits: ['switchDetailView'],
  setup(__props, { emit }) {

const props = __props



const { localeDateStringShort } = useConverter();
const { truncate } = useStringManip();



function switchDetailView() {
  emit('switchDetailView', { messageid: props.message.id, detail: '1' }, true);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "media message-short-tile",
    id: 'message' + __props.message.id
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["media-left", __props.message.thumbnail_sq64 ? 'has-picture' : 'no-picture']),
      style: _normalizeStyle(`--wdw-marker-bg-url: url('${__props.message.marker_uri}');`)
    }, [
      _createElementVNode("div", _hoisted_2, [
        (__props.message.thumbnail_sq64)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "img-responsive",
              src: __props.message.thumbnail_sq64,
              width: "256",
              height: "256",
              alt: "Foto zur Meldung"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "bms-marker",
          style: _normalizeStyle(`--wdw-marker-bg-url: url('${__props.message.marker_uri}');`)
        }, null, 4)
      ])
    ], 6),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(__props.message.address), 1)
      ]),
      _createElementVNode("a", { onClick: switchDetailView }, [
        _createElementVNode("h4", _hoisted_8, _toDisplayString(_unref(truncate)(__props.message.text, 65, true)), 1)
      ]),
      _createElementVNode("span", _hoisted_9, [
        _hoisted_10,
        _createTextVNode(" " + _toDisplayString(__props.message.id), 1)
      ]),
      _createElementVNode("span", _hoisted_11, [
        _hoisted_12,
        _createTextVNode(" " + _toDisplayString(_unref(localeDateStringShort)(__props.message.created)), 1)
      ]),
      _createElementVNode("span", _hoisted_13, [
        _hoisted_14,
        _createTextVNode(" " + _toDisplayString(__props.message.message_type.name), 1)
      ]),
      _createElementVNode("span", _hoisted_15, [
        _hoisted_16,
        _createTextVNode(" " + _toDisplayString(_unref(messageStateTypeMappedToGermanText)[__props.message.state]), 1)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})